import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {AllocationRequest} from "../../../../../model/clearing/allocation/allocation-request";
import {ClearingAllocationService} from "../../../../../services/clearing/clearing-allocation.service";
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {Trade} from "../../../../../model/clearing/trade";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-override-custom-reference-form',
  templateUrl: './override-custom-reference-form.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverrideCustomReferenceFormComponent extends CcBaseComponent {

  transPartKey: string = 'clearing.trade';

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: AllocationRequest | any;

  loadingProgressValue: number = 100;
  dialogFormVisible: boolean = false;

  @Output()
  onSavedForm = new EventEmitter<any>();

  constructor(cdref: ChangeDetectorRef,
              private allocationService: ClearingAllocationService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.override_custom_reference');
    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'customReference',
            column: 12,
            type: TYPE.TEXT,
            focused: true
          }]
      }];
  }

  public open(selectedIds: string[], firstTrade: Trade): void {
    if (selectedIds && selectedIds.length > 0) {
      const newFormRecord = {
        tradeIds: selectedIds,
        customReference: firstTrade.customOrderReference
      }
      this.openWithRecord(newFormRecord);
    }
  }

  public openWithRecord(newFormRecord: any): void {
    this.formRecord = newFormRecord;
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  save() {
    this.formLoading = true;
    this.allocationService.overrideCustomReference(this.formRecord.tradeIds,  this.formRecord.customReference).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.markForCheck();
  }

}
